import { toAbsoluteUrl } from './AssetHelpers';
import { KTSVG } from './components/KTSVG';

export const ToastifySuccess = () => {
  return <KTSVG path={toAbsoluteUrl('/media/svg/toast/toast-success-icon.svg')} />;
};

export const ToastifyError = () => {
  return <KTSVG path={toAbsoluteUrl('/media/svg/toast/toast-error-icon.svg')} />;
};

export const ToastifyCloseSuccess = () => {
  return (
    <span>
      <KTSVG path={toAbsoluteUrl('/media/svg/toast/close-icon-success.svg')} />
    </span>
  );
};

export const ToastifyCloseError = () => {
  return (
    <span>
      <KTSVG path={toAbsoluteUrl('/media/svg/toast/close-icon-error.svg')} />
    </span>
  );
};
